import getInterleavedSearchExperimentStore from '../store/store';

export function clearInterleavedSearchMetadata(): void {
    getInterleavedSearchExperimentStore().currentInterleavedSearchMetadata = undefined;
}
